/* =========================================================================
   My Prolearning — Product page
   Real gallery (thumbs ↔ stage), variant option selectors (price / stock /
   image), quantity, sticky buy bar, scroll progress, reveal + stat bars.
   Add-to-cart is handled globally by mpl-chrome.js (form has .mpl-add-form),
   which opens the cart drawer.
   ========================================================================= */
(function () {
  "use strict";
  var root = document.querySelector(".mpl-pp");
  if (!root) return;

  var currency = root.getAttribute("data-currency") || "EUR";
  function money(cents) {
    try { return new Intl.NumberFormat("fr-FR", { style: "currency", currency: currency }).format((cents || 0) / 100); }
    catch (e) { return "€" + ((cents || 0) / 100).toFixed(2).replace(".", ","); }
  }

  /* ---------------- gallery ---------------- */
  var stageImg = document.getElementById("mplPpStageImg");
  var thumbs = [].slice.call(root.querySelectorAll(".thumb[data-src]"));
  function setStage(src, idx) {
    if (stageImg && src) stageImg.src = src;
    thumbs.forEach(function (t, i) { t.classList.toggle("active", i === idx); });
  }
  thumbs.forEach(function (t, i) {
    t.addEventListener("click", function () { setStage(t.getAttribute("data-src"), i); });
  });

  /* ---------------- variants ---------------- */
  var variants = [];
  var vdata = document.getElementById("mplPpVariants");
  if (vdata) { try { variants = JSON.parse(vdata.textContent); } catch (e) { variants = []; } }
  var selects = [].slice.call(root.querySelectorAll("[data-mpl-option]"));
  var hiddenId = root.querySelector("[data-mpl-variant-id]");
  var priceNow = document.getElementById("mplPpPriceNow");
  var priceExtra = document.getElementById("mplPpPriceExtra");
  var addBtn = document.getElementById("mplPpAdd");
  var sbPrice = document.getElementById("mplPpSbPrice");

  function applyVariant(v) {
    if (!v) {
      if (addBtn) { addBtn.classList.add("soldout"); addBtn.disabled = true; addBtn.textContent = "Indisponible"; }
      return;
    }
    if (hiddenId) hiddenId.value = v.id;
    if (priceNow) priceNow.textContent = money(v.price);
    if (sbPrice) sbPrice.textContent = money(v.price);
    if (priceExtra) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var save = Math.round((1 - v.price / v.compare_at_price) * 100);
        priceExtra.innerHTML = '<span class="price-was">' + money(v.compare_at_price) + '</span>' +
          '<span class="price-save">−' + save + ' %</span>';
      } else { priceExtra.innerHTML = ""; }
    }
    if (addBtn) {
      if (v.available) { addBtn.classList.remove("soldout"); addBtn.disabled = false; addBtn.innerHTML = addBtn.getAttribute("data-label") || "Ajouter au panier"; }
      else { addBtn.classList.add("soldout"); addBtn.disabled = true; addBtn.textContent = "Épuisé"; }
    }
    /* swap gallery to the variant image when it has its own */
    if (v.featured_image && v.featured_image.src && stageImg) {
      stageImg.src = v.featured_image.src;
    }
  }
  function currentVariant() {
    if (!selects.length) return variants[0];
    var chosen = selects.map(function (s) { return s.value; });
    return variants.find(function (v) {
      return v.options && v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
    });
  }
  if (selects.length) {
    selects.forEach(function (s) { s.addEventListener("change", function () { applyVariant(currentVariant()); }); });
    applyVariant(currentVariant());
  }

  /* ---------------- quantity ---------------- */
  var qty = document.getElementById("mplPpQty");
  var qMinus = document.getElementById("mplPpQtyMinus");
  var qPlus = document.getElementById("mplPpQtyPlus");
  if (qMinus && qty) qMinus.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
  if (qPlus && qty) qPlus.addEventListener("click", function () { qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); });

  /* ---------------- sticky bar add -> submit main form ---------------- */
  var form = document.getElementById("mplPpForm");
  var sbAdd = document.getElementById("mplPpSbAdd");
  if (sbAdd && form) sbAdd.addEventListener("click", function () {
    if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
  });

  /* ---------------- scroll progress · sticky · back-to-top · reveal ---------------- */
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var bar = document.getElementById("mplPpBar");
  var sticky = document.getElementById("mplPpSticky");
  var totop = document.getElementById("mplPpTop");
  var buybox = root.querySelector(".buybox");
  var footer = document.querySelector(".mpl-footer");

  function onScroll() {
    var y = window.scrollY || 0;
    if (bar) { var h = document.documentElement.scrollHeight - window.innerHeight; bar.style.width = (h > 0 ? (y / h * 100) : 0) + "%"; }
    if (sticky && buybox) {
      var boxBottom = buybox.getBoundingClientRect().bottom;
      var nearFoot = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      sticky.classList.toggle("show", boxBottom < 60 && !nearFoot);
    }
    if (totop) totop.classList.toggle("show", y > 700);
  }
  window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  if (totop) totop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" }); });

  function countUp(el, to, suffix) {
    var start = performance.now();
    (function tick(now) {
      var p = Math.min(1, (now - start) / 1100), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * e) + (suffix || "");
      if (p < 1) requestAnimationFrame(tick);
    })(start);
  }

  var reveals = [].slice.call(root.querySelectorAll(".reveal"));
  var titles = [].slice.call(root.querySelectorAll(".sec h2"));
  if (reduce || !("IntersectionObserver" in window)) {
    reveals.forEach(function (e) { e.classList.add("in"); });
    titles.forEach(function (h) { h.classList.add("drawn"); });
    root.querySelectorAll(".fill").forEach(function (f) { f.style.width = f.getAttribute("data-v") + "%"; });
    return;
  }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting) return;
      var t = en.target;
      var sibs = [].slice.call(t.parentElement.children).filter(function (c) { return c.classList.contains("reveal"); });
      t.style.transitionDelay = (Math.max(0, sibs.indexOf(t)) * 70) + "ms";
      t.classList.add("in");
      var f = t.querySelector ? t.querySelector(".fill") : null; if (f) f.style.width = f.getAttribute("data-v") + "%";
      io.unobserve(t);
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
  reveals.forEach(function (e) { io.observe(e); });

  var titleIO = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("drawn"); titleIO.unobserve(en.target); } });
  }, { threshold: 0.5 });
  titles.forEach(function (h) { titleIO.observe(h); });

  var once = new WeakSet();
  var countIO = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting || once.has(en.target)) return;
      once.add(en.target); if (en.target.__run) en.target.__run(); countIO.unobserve(en.target);
    });
  }, { threshold: 0.6 });
  var pct = root.querySelector(".pct-badge");
  if (pct) { pct.__run = function () { countUp(pct, 150, " %"); }; pct.textContent = "0 %"; countIO.observe(pct); }
  root.querySelectorAll(".statbar .val").forEach(function (v) {
    var n = parseInt(v.textContent, 10);
    var f = v.closest(".statbar").querySelector(".fill");
    v.__run = function () { countUp(v, n, "%"); if (f) f.style.width = n + "%"; };
    v.textContent = "0%"; countIO.observe(v);
  });
})();
